import React from 'react';
import PropTypes from 'prop-types';
// common components
import CustomButton from './../Forms/CustomButton/CustomButton';
import './PageHeader.scss';

const PageHeader = ({ title, onAdd, btnText, isToggle, toggleValue, onToggle, bulkUpload }) => (
	<div className='PageHeader page-heading'>
		<div className="heading">{title}</div>
		<div className="actions">
			{title !== 'User' && (
				<CustomButton
					plain
					iconName='plus'
					name={`Add ${btnText}`}
					onClick={onAdd}
				/>
			)}
			{title === 'participants' && (
				<React.Fragment>
					<div className='line' />
					<CustomButton
						plain
						iconName='upload'
						name="Bulk Upload"
						onClick={bulkUpload}
					/>
				</React.Fragment>
			)}
			{isToggle && (
				<React.Fragment>
					<div className='line' />
					<CustomButton
						iconOnly
						iconName={toggleValue ? 'list' : 'table'}
						name={toggleValue ? 'List View' : 'Table View'}
						onClick={onToggle}
					/>
				</React.Fragment>
			)}
		</div>
	</div>
);

PageHeader.propTypes = {
	title: PropTypes.string,
	onAdd: PropTypes.func,
	btnText: PropTypes.string,
	isToggle: PropTypes.bool,
	toggleValue: PropTypes.bool,
	onToggle: PropTypes.func,
	bulkUpload: PropTypes.func
};

PageHeader.defaultProps = {
	title: '',
	onAdd: () => { },
	btnText: '',
	isToggle: false,
	toggleValue: false,
	onToggle: () => { },
	bulkUpload: () => {}
};

export default PageHeader;



// WEBPACK FOOTER //
// ./common/PageHeader/PageHeader.js